import { createApp } from 'vue'
import { SetupCalendar } from 'v-calendar'

import store from '@/store'
import { i18n } from '@/plugins/i18n'

import App from './App.vue'
import { plugins, services } from 'common'

const elem = document.getElementById('rs-frontend-app')

export const app = createApp(App, { ...elem.dataset })

app.use(SetupCalendar, {})

const media = plugins.createMedia()
app.use(media)

const alert = plugins.createAlert()
app.use(alert)

const readMore = plugins.createReadMore()
app.use(readMore)

app.use(i18n)
app.use(store)

app.config.globalProperties.$filters = {
  dateFormat: services.FilterService.dateFormat,
  capitalize: services.FilterService.capitalize
}

app.mount(elem)
